import { render, staticRenderFns } from "./cloud-no-header-dialog.vue?vue&type=template&id=0fdf87cd&scoped=true"
import script from "./cloud-no-header-dialog.vue?vue&type=script&lang=js"
export * from "./cloud-no-header-dialog.vue?vue&type=script&lang=js"
import style1 from "./cloud-no-header-dialog.vue?vue&type=style&index=1&id=0fdf87cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf87cd",
  null
  
)

export default component.exports